import { Content } from "@/ui/Content";
import { stripTags } from "@/functions/stripTags";
import { getGlobal } from "@/functions/getGlobal";
import { parseRoute } from "@/functions/parseRoute";
import * as additionalComponents from "@/components/SpecialismsPage";
import sourceflowEnums from "@/sourceflow.enums";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps() {
  const global = getGlobal();

  const routerProp = parseRoute("specialism");
  const pagePrefix = `page.specialism`;

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global[`${pagePrefix}.banner.title.en`]),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
        },
      },
      router: routerProp,
      content: [{ component: "SpecialismsPageBannerSection" }],
    },
  };
}
